import { useMutation } from "@tanstack/react-query"
import { structuredOutput, summarize } from "../api/ai"

const useSummarize = (setResponse, responseType) => {
  const api = responseType !== "AI Summary" ? structuredOutput : summarize
  return useMutation({
    mutationFn: api,
    onSuccess: (data) => {
      setResponse(data)
    },
  })
}

export default useSummarize
